export default __webpack_public_path__ + "static/media/coding-quiz.e9726864.png";